import type { AppDataTableColumn } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { AppBadgeForAno } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { SalesStageBadge } from '@opportunities/-components/SalesStageBadge'
import type { GetInquirySalesResponse } from 'backend/types'
import { formatCurrency, formatDate } from '@/lib/format-utils'

type InquirySale = GetInquirySalesResponse['sales'][number]

export function createSalesColumns(): AppDataTableColumn<InquirySale>[] {
  return [
    {
      key: 'sales_id',
      label: '売上情報ID',
      accessor: (row) => row.sales_id,
      render: (row) => <span className='font-mono text-sm'>{row.sales_id}</span>,
    },
    {
      key: 'ano',
      label: 'ANO',
      accessor: (row) => row.ano,
      sortable: false,
      cellClassName: 'w-[100px]',
      render: (row) => <AppBadgeForAno ano={row.ano} />,
    },
    {
      key: 'salesforce_project_name',
      label: 'ANOの案件名',
      accessor: (row) => row.salesforce_project_name,
      sortable: false,
      cellClassName: 'min-w-[250px]',
      active: true,
      render: (row) => (
        <span className='block' title={row.salesforce_project_name || undefined}>
          {row.salesforce_project_name || '-'}
        </span>
      ),
    },
    {
      key: 'amount',
      label: '売上金額',
      accessor: (row) => row.amount,
      sortable: false,
      headerClassName: '[&>div]:justify-center',
      cellClassName: 'text-right min-w-[100px]',
      render: (row) => <span className='text-right'>{formatCurrency(row.amount) || '-'}</span>,
      footer: (data) => {
        const total = data.reduce((sum, item) => sum + (item.amount ?? 0), 0)
        return <span className='text-right text-xs'>合計: {formatCurrency(total)}</span>
      },
      footerClassName: 'text-right',
    },
    {
      key: 'sales_stage_id',
      label: 'Sales Stage',
      accessor: (row) => row.sales_stage_id,
      sortable: true,
      cellClassName: 'text-center min-w-25',
      render: (row) => <SalesStageBadge stageId={row.sales_stage_id} variant='default' />,
    },
    {
      key: 'sales_on',
      label: '売上月',
      accessor: (row) => row.sales_on,
      sortable: false,
      cellClassName: 'text-center min-w-[100px]',
      render: (row) => <span>{formatDate(row.sales_on, 'salesMonth')}</span>,
    },
  ]
}
